var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tags__container"},_vm._l((_vm.words),function(category){return _c('div',{key:category.color,staticClass:"tags__category"},_vm._l((category.words),function(word){return _c('div',{key:word,staticClass:"tag",style:({
        color: category.color,
        backgroundColor: category.backgroundColor
      })},[_vm._v(" "+_vm._s(word)+" ")])}),0)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }